const SHORT = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short' });
const LONG = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
const CLOCK = new Intl.DateTimeFormat('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });

/** "today", "2 days ago", then a date: how the flag list says when something was last edited. */
export function formatEdited(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const days = Math.floor((startOfDay(now) - startOfDay(date)) / 86_400_000);
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days} days ago`;
  return SHORT.format(date);
}

/** "Today, 11:20 AM" / "15 Oct, 4:02 PM": the timestamp under a change-history entry. */
export function formatStamp(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const day = startOfDay(now) === startOfDay(date) ? 'Today' : SHORT.format(date);
  return `${day}, ${CLOCK.format(date).toUpperCase()}`;
}

/** "3 Oct 2026" for "Last changed by Priya Sharma · 3 Oct 2026". */
export const formatChangedDate = (iso: string): string => LONG.format(new Date(iso));

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}
